import { Box } from "@mui/material";

const SidebarStatusTag = ({ type }) => {
  const styles = [
    {id: 1, name: 'beta', style: {
      background: "#ffefca",
      color: "#bc3803",
      border: "1px solid #ffcc85",
    }},
    {id: 2, name: 'new', style: {
      background: "#e2f6e8",
      color: "#0f6a2b",
      border: "1px solid #8be0a8",
    }},
    {id: 3, name: 'pro', style: {
      background: "#e3e7ff",
      color: "#1e2dbf",
      border: "1px solid #b8c4ff",
    }}
  ];

  const selected = styles.find(item => item.id === type);

  return (
    <Box
      component="span"
      sx={{
        ...selected.style,
        textTransform: "uppercase",
        marginLeft: "6px",
        padding: "2px 6px",
        display: "inline-block",
        borderRadius: "4px",
        fontWeight: 700,
        fontSize: "0.65em",
      }}
    >
      {selected.name}
    </Box>
  );
};

export default SidebarStatusTag;
